import { useCallback, useEffect, useState } from 'react';

const INITIAL_ZOOM = 13;

const useMapInteraction = ({ allFilteredHotels, mapRef, mapLoaded }) => {
  const [initialMapSet, setInitialMapSet] = useState(false);

  const centerMapIfHotelOutOfView = useCallback(
    hotel => {
      if (!mapRef?.current || !hotel?.location) return;

      const map = mapRef.current;
      const bounds = map.getBounds();
      const hotelLatLng = new window.google.maps.LatLng(
        hotel.location.latitude,
        hotel.location.longitude
      );

      if (!bounds?.contains(hotelLatLng)) {
        map.panTo(hotelLatLng);
      }
    },
    [mapRef]
  );

  // El centro ya lo pone el prop `center` (hotel más barato). Acá solo fijamos
  // un zoom inicial razonable, en vez de fitBounds sobre todos los hoteles
  // (que con resultados muy dispersos terminaba alejando la vista a "toda Europa").
  const recenterMapToHotels = useCallback(() => {
    if (!mapRef?.current || allFilteredHotels.length === 0) {
      return;
    }

    mapRef.current.setZoom(INITIAL_ZOOM);
  }, [mapRef, allFilteredHotels]);

  useEffect(() => {
    if (mapLoaded && !initialMapSet && allFilteredHotels.length > 0) {
      recenterMapToHotels();
      setInitialMapSet(true);
    }
  }, [mapLoaded, allFilteredHotels, recenterMapToHotels, initialMapSet]);

  return {
    centerMapIfHotelOutOfView,
  };
};

export default useMapInteraction;
